import {Component, Input} from '@angular/core';

import { NavController, AlertController } from 'ionic-angular';
import { CrearOrdenPage } from '../../pages/crear-orden/crear-orden';
import { AuthProvider } from '../../providers/auth/auth';
import { LoginPage } from '../../pages/login/login';

/**
 * Generated class for the ToolbarCustomComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'toolbar-custom',
  templateUrl: 'toolbar-custom.html'
})
export class ToolbarCustomComponent {

  @Input() title: string;
  @Input() hideHome: boolean;

  constructor(
    public navCtrl: NavController,
    private alertCtrl: AlertController,
    private authProvider: AuthProvider,) {}

  goHome(){
    this.navCtrl.push(CrearOrdenPage);
    }

    closeSession() {
      this.alertCtrl.create({
        subTitle: '¿Estas seguro que deseas cerrar sesión?',
        buttons: [
          'Cancelar',
          {
            text: 'Entendido',
            handler: () => {
              this.authProvider.clearCredentials()
                .then(() => this.navCtrl.setRoot(LoginPage));
            }
          }
        ]
      }).present();
    }
}




// WEBPACK FOOTER //
// ./src/components/toolbar-custom/toolbar-custom.ts